export const seriesId = [
  "vpibpc",
  "titpct",
  "tdpct",
  "tabpct",
  "vptrapct",
  "prosp",
  "perccorr",
  "effgov",
  "le",
  "cd",
  "tipc",
  "tir",
  "scc",
  "vtp",
  "cae",
  "sp",
  "dpub",
  "dpriv",
  "piin",
  "tipdp",
  "dext"
]

export const seriesEsp = [
  "Variación del PIBpc",
  "Tasa de inversión total (% PIB)",
  "Tasa de desempleo (%)",
  "Tasa de ahorro bruto (% PIB)",
  "Variación de la Productividad por Trabajador (%)",
  "Prosperidad ",
  "Percepción de la Corrupción",
  "Efectividad del Gobierno",
  "Libertad Económica",
  "Calidad democrática",
  "Tasa de inflación (IPC; %)",
  "Tipo de interés de referencia (%)",
  "Saldo por cuenta corriente (valor absoluto; % del PIB)",
  "Variabilidad tipo de cambio (valor absoluto; %)",
  "Coeficiente de Apertura Externa (%)",
  "Saldo presupuestario (% del PIB)",
  "Deuda pública (% del PIB)",
  "Deuda privada (% PIB)",
  "Posición Internacional de Inversión Neta (%)",
  "Tipos de interés deuda pública (%)",
  "Deuda externa (% del PNB)",
]

export const seriesEng = [
  "GDPpc variation",
  "Total investment rate (% GDP)",
  "Unemployment rate (%)",
  "Gross savings rate (% GDP)",
  "Variation in Productivity per Worker (%)",
  "Prosperity ",
  "Perception of Corruption",
  "Government Effectiveness",
  "Economic freedom",
  "Democratic quality",
  "Inflation rate (CPI; %)",
  "Reference interest rate (%)",
  "Current account balance (absolute value; % of GDP)",
  "Exchange rate variability (absolute value; %)",
  "External Opening Coefficient (%)",
  "Budget balance (% of GDP)",
  "Public debt (% of GDP)",
  "Private debt (% GDP)",
  "International Net Investment Position (%)",
  "Public debt interest rates (%)",
  "External debt (% of GNP)",
]

export const groupsEsp = [
  "Dinámica del crecimiento económico",
  "Dinámica del crecimiento económico",
  "Dinámica del crecimiento económico",
  "Dinámica del crecimiento económico",
  "Dinámica del crecimiento económico",
  "Calidad institucional",
  "Calidad institucional",
  "Calidad institucional",
  "Calidad institucional",
  "Calidad institucional",
  "Dinámica monetaria y de sector exterior",
  "Dinámica monetaria y de sector exterior",
  "Dinámica monetaria y de sector exterior",
  "Dinámica monetaria y de sector exterior",
  "Dinámica monetaria y de sector exterior",
  "Dinámica del endeudamiento global",
  "Dinámica del endeudamiento global",
  "Dinámica del endeudamiento global",
  "Dinámica del endeudamiento global",
  "Dinámica del endeudamiento global",
  "Dinámica del endeudamiento global"
]

export const groupsEng = [
  "Dynamics of economic growth",
  "Dynamics of economic growth",
  "Dynamics of economic growth",
  "Dynamics of economic growth",
  "Dynamics of economic growth",
  "Institutional quality",
  "Institutional quality",
  "Institutional quality",
  "Institutional quality",
  "Institutional quality",
  "Monetary and foreign sector dynamics",
  "Monetary and foreign sector dynamics",
  "Monetary and foreign sector dynamics",
  "Monetary and foreign sector dynamics",
  "Monetary and foreign sector dynamics",
  "Dynamics of global debt",
  "Dynamics of global debt",
  "Dynamics of global debt",
  "Dynamics of global debt",
  "Dynamics of global debt",
]

export const countriesDataEsp = [
  "Australia",
  "Austria",
  "Bélgica",
  "Canadá",
  "República Checa",
  "Dinamarca",
  "Finlandia",
  "Francia",
  "Alemania",
  "Grecia",
  "Hong Kong SAR",
  "Irlanda",
  "Israel",
  "Italia",
  "Japón",
  "Corea del Sur",
  "Países Bajos",
  "Noruega",
  "Portugal",
  "Singapur",
  "España",
  "Suecia",
  "Suiza",
  "Taiwán",
  "Reino Unido",
  "Estados Unidos de América",
  "Argelia",
  "Argentina",
  "Bangladesh",
  "Brasil",
  "Chile",
  "China",
  "Colombia",
  "Egipto",
  "Hungría",
  "India",
  "Indonesia",
  "Irán",
  "Kazajstán",
  "Kuwait",
  "Malasia",
  "México",
  "Marruecos",
  "Nigeria",
  "Pakistán",
  "Perú",
  "Filipinas",
  "Polonia",
  "Katar",
  "Rumania",
  "Rusia",
  "Arabia Saudita",
  "Sudáfrica",
  "Sri Lanka",
  "Thailandia",
  "Turquía",
  "Ucrania",
  "Emiratos Árabes Unidos",
  "Venezuela",
  "Vietnam"
]

export const countriesDataEng = [
  "Australia",
  "Austria",
  "Belgium",
  "Canada",
  "Czechia",
  "Denmark",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Hong Kong",
  "Ireland",
  "Israel",
  "Italy",
  "Japan",
  "South Korea",
  "Netherlands",
  "Norway",
  "Portugal",
  "Singapore",
  "Spain",
  "Sweden",
  "Switzerland",
  "Taiwan",
  "United Kingdom",
  "United States of America",
  "Algeria",
  "Argentina",
  "Bangladesh",
  "Brazil",
  "Chile",
  "China",
  "Colombia",
  "Egypt",
  "Hungary",
  "India",
  "Indonesia",
  "Iran",
  "Kazakhstan",
  "Kuwait",
  "Malaysia",
  "Mexico",
  "Morocco",
  "Niger",
  "Pakistan",
  "Peru",
  "Philippines",
  "Poland",
  "Qatar",
  "Romania",
  "Russia",
  "Saudi Arabia",
  "South Africa",
  "Sri Lanka",
  "Thailand",
  "Turkey",
  "Ukraine",
  "United Arab Emirates",
  "Venezuela",
  "Vietnam"
]
